<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500"
      @click:outside="close"
      :persistent="loading"
      scrollable
      contentClass="rounded-lg"
    >
      <v-card>
        <v-card-title>Código de Acesso</v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent>
            <div outlined class="d-flex gap-4 align-center mb-8">
              <v-avatar size="56" color="primary">
                <v-icon color="white" large>mdi-account</v-icon>
              </v-avatar>
              <div>
                <h4 class="mb-0">{{ client.name }}</h4>
                <a :href="`//wa.me/55${client.phone}`" target="_blank">
                  <v-icon color="primary" small>mdi-phone</v-icon>
                  {{ client.phone || "" | phone }}
                </a>
                <div class="d-flex gap-1">
                  <v-icon small>mdi-office-building</v-icon>
                  <p class="mb-0">
                    {{ blocks[client.blockId] }} - {{ client.apartment }}
                  </p>
                </div>
              </div>
            </div>
            <v-text-field
              v-model="client.accessId"
              label="Código da portaria"
              :disabled="loading"
              placeholder="Deixe em branco caso não cadastrado"
              outlined
              autofocus
              hide-details
              type="tel"
            />
            <ClientAccessIdSearch
              :accessId="client.accessId"
              class="mt-2"
              canRegister
              @registerFace="registerFace"
            />
            <div class="d-flex align-center gap-2">
              <v-divider />
              OU
              <v-divider />
            </div>
            <v-btn @click="registerFace" block>Criar cadastro facial</v-btn>
            <v-alert v-if="error" type="error" border="left">
              {{ error }}
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-switch
            v-if="client.id"
            v-model="client.active"
            label="Ativo"
            :disabled="loading"
            dense
            class="mt-0"
            hide-details
          ></v-switch>
          <v-spacer></v-spacer>
          <v-btn @click="close" text :disabled="loading"> Cancelar </v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            @click="save"
            :disabled="!valid"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FaceCaptureModal />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import STORE from "@/services/store";
import ClientAccessIdSearch from "./ClientAccessIdSearch.vue";
import FaceCaptureModal from "./FaceCaptureModal.vue";

const defaultObject = () => ({
  name: "",
  document: "",
  accessId: null,
  active: true,
});

export default {
  name: "AccessIdModal",
  components: {
    ClientAccessIdSearch,
    FaceCaptureModal,
  },
  data: () => ({
    dialog: false,
    loading: false,
    valid: false,
    error: false,
    client: defaultObject(),
  }),
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = false;

        await STORE.client.update(this.selectedStore.id, this.client.id, {
          accessId: this.client.accessId,
          active: this.client.active,
        });

        this.loading = false;
        this.$emit("success");
        this.close();
      } catch (e) {
        this.error = e.message || "Erro desconhecido";
        this.loading = false;
      }
    },
    open(client) {
      this.client = Object.assign(defaultObject(), client);
      this.register = false;
      this.dialog = true;
    },
    close() {
      if (this.loading) return;
      this.dialog = false;
      this.error = false;
    },
    registerFace() {
      this.$root.$emit("face-capture-modal", {
        accessId: this.client.accessId,
        client: this.client,
      });
    },
  },
  computed: {
    ...mapGetters("store", ["selectedStore"]),
    store() {
      return this.selectedStore;
    },
    blocks() {
      return Object.fromEntries(
        this.store.Condominium.Blocks.map((b) => [b.id, b.name])
      );
    },
  },
};
</script>

<style></style>
